<div class="main-wrapper">
    <div class="main-row">
        <div class="inner-wrapper">
            <div class="back-button">
                <a href="javascript:void(0)" (click)="goBack()">
                    <img src="../../assets/svg/fi-rs-arrow-left.svg" alt="Back" loading="lazy"/>
                </a>
            </div>
            <div class="header">
                <div class="flexed">
                    <a routerLink="/">
                        <img src="../../assets/img/safetly_image.webp" alt="Safetly Logo" loading="lazy"/>
                    </a>
                </div>
            </div>
            <div class="body">
                <div class="download-container">
                    <h1>{{'download.title' | translate}}</h1>

                    <div class="download-qr-code-section" *ngIf="showQrCode">
                        <div class="qr-code-box">
                            <img src="https://api.qrserver.com/v1/create-qr-code/?size=250x250&amp;data=https://safetly.se/app-redirect" alt="QR code to download the Safetly app" class="w-full h-full" loading="lazy"/>
                        </div>

                        <div class="qr-code-content">
                            {{'download.qr-code-content' | translate}}
                        </div>
                    </div>

                    <div class="download-options">
                        <div class="download-card" (click)="downloadIOS()">
                            <div class="icon-container">
                                <img src="../../assets/img/apple-icon.png" alt="Apple App Store" loading="lazy"/>
                                <div class="download-text">
                                    <p>{{'download.apple' | translate}}</p>
                                    <h4>App Store</h4>
                                </div>
                            </div>
                        </div>

                        <div class="download-card" (click)="downloadAndroid()">
                            <div class="icon-container">
                                <img src="../../assets/img/google-play-store-icon.png" alt="Google Play Store" loading="lazy"/>
                                <div class="download-text">
                                    <p>{{'download.google' | translate}}</p>
                                    <h4>Google Play</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>